
import { useRef, useEffect} from 'react';
import { useHistory } from 'react-router';
import { useAppContext } from '../../appProvider/contextProvider';
import ChirpyWebLg from '../../assets/icons/ChirpyWebLogoFull.svg';
import Profile from '../../assets/icons/defaultProfile.svg';



const Header = ({setMenuToggled}) =>{

    const history = useHistory();

    const ref = useRef(null);

    const { websites,
        selectedWebsite, 
        userDetails, 
        setMenuOpen, 
        isMenuOpen, 
        resetAllStates,
        setPricingPopupOpen,
        getSelectedWebsite
    } = useAppContext();
    
    useEffect(() => {
        /**
         * Alert if clicked on outside of element
         */
        const handleClickOutside = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                setMenuOpen(false);
            }
        }

        // Bind the event listener
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [ref]);

    const onChangeSelection = (_url) => {
        const selectedWebsite = websites.find(({url}) => url === _url);
        getSelectedWebsite(selectedWebsite?.id);
        localStorage.setItem('selected_website', selectedWebsite?.id);
    }

    const logout = () => {
        setMenuOpen(false);
        localStorage.removeItem('user_id');
        localStorage.removeItem('token');
        resetAllStates();
        history.push('/login');
    }

    const navigateTo = (path) =>{
        setMenuOpen(false);
        history.push(path);
    }

    const openPricingPopup = () => {
        setMenuOpen(false);
        setPricingPopupOpen(true);
    }

    const getSortedWebsites = () => {
        return websites.sort((a, b) => {
            let firstUrl = '';
            let secondUrl = '';
            if(a.url.includes('https://www.')) {
                firstUrl = a.url.split('https://www.')[1];
            } else {
                firstUrl = a.url.split('https://')[1];
            }
            if(b.url.includes('https://www.')) {
                secondUrl = b.url.split('https://www.')[1];
            } else {
                secondUrl = b.url.split('https://')[1];
            }
            return firstUrl > secondUrl ? 1 : -1;
        })
    }

    return <header className="full-width">
    <div className="d-flex justify-content-between align-items-center full-width">
        <div className="d-flex">
            <button onClick={() => setMenuToggled(true)} className="toggle-btn d-block d-lg-none">
                <span></span>
            </button>
            <a onClick={() => history.push('/dashboard')} className="logo-container-sm d-sm-block d-md-none" style={{top: 'auto'}} >
                <img src={ChirpyWebLg} alt="logo" style={{maxWidth: '7rem'}} />
            </a>
            <div className="form-group mb-0 d-none d-md-block">
                <div className="custom-select custom-select-icon">
                    <i className="icon icon-website"></i>
                    <select value={selectedWebsite ? selectedWebsite.url : ''} onChange={({target}) => onChangeSelection(target.value)}  className="form-control">
                        { 
                           selectedWebsite && websites.length && getSortedWebsites().map((website, index) => <option value={website.url}  key={index}>{website.url}</option>)
                        }
                    </select>
                </div>
            </div>
        </div>                            
        <div className="d-flex align-items-center">
            <div className="profile-avatar d-none d-md-block">
                <img src={Profile} alt="Profile"/>
            </div>
            <div className="dropdown">                                
                <button onClick = {() => setMenuOpen(!isMenuOpen)} className="btn dropdown-toggle" type="button" id="dropdownMenu2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                 <span className="d-none d-md-block">{userDetails?.name}</span>
                 <span className="d-none d-md-block" style={{textTransform: 'capitalize'}} >{selectedWebsite?.user_type}</span>
                 <i className="icon icon-profile d-block d-md-none"  ></i>
                </button>
                { isMenuOpen && <div ref={ref}  className="dropdown-menu show" aria-labelledby="dropdownMenu2">
                        <div className="dropdown-notch"></div>
                        <button className="dropdown-item" onClick={() => navigateTo('/profile')} type="button">
                        <i className="icon icon-profile"></i>Profile</button>
                        {/* <button className="dropdown-item" onClick={paymentProfile.mutate} type="button">
                        <i className="icon icon-settings"></i>Account Settings</button> */}
                        {/* <button className="dropdown-item" type="button">
                            <i className="icon icon-file"></i>Documentation</button> */}
                        <button className="dropdown-item" onClick={() => navigateTo('/billing')} type="button">
                            <i className="icon icon-money"></i>Billing/Pricing</button>
                        <button className="dropdown-item" onClick={openPricingPopup}  type="button">
                        <i className="icon icon-currency" ></i>Plans</button>
                        <button className="dropdown-item" type="button" onClick={logout} >
                        <i className="icon icon-logout"></i>Logout</button>
                </div>}
            </div>                          
        </div>
    </div>
</header>}



export default Header;